import React, { useState, useEffect } from 'react'
import {MultiSelect} from "react-multi-select-component"
//import DatetimeRangePicker from 'react-datetime-range-picker';
import moment from 'moment'
import utils from '../../services/utils'
import constants, { SEARCH_PARAM_DEPARTMENT } from '../../constants'
import './ConversationsSearchCriteria.css'
import './ConversationsSearchCriteria.css'
//import 'antd/dist/antd.css';
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;

const ConversationsSearchCriteria = (props) => {
    const { channels, queues, role, divisions ,titles, departments, region, locations,agents,conv_direction} = props
    const [dnis, setDNIS] = useState()
    const [ani, setANI] = useState()
    const [conversationID, setConversationID] = useState()

    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [selectedDivisions, setSelectedDivisions] = useState([])
    const [selectedDepartments, setSelectedDepartments] = useState([])
    const [selectedTitles, setSelectedTitles] = useState([])
    const [selectedAgents, setSelectedAgents] = useState([])
    //const [selectedLocations, setSelectedLocations] = useState([])
    const [selectedConvDirection, setSelectedConvDirection] = useState([])
    const [selectedRegion, setSelectedRegion] = useState([])
    const [selectedQueues, setSelectedQueues] = useState([])
    const [selectedClients, setSelectedClients] = useState([])
    const [startSearch, setStartSearch] = useState(false)
    const [dateRange, setdateRange] = useState([]); // 0th position - startDate , 1st position - end Date
    
    function onSelectDate(dateArray, dateString) {
        console.log(`onSelectDate value is ${JSON.stringify(dateString)}`);
        setdateRange(dateString);
    }
    // init from session storage
    useEffect(() => {
        try {
            //console.log(`ConversationsSearchCriteria:::departments are ${JSON.stringify(departments)}`)
            //console.log(`ConversationsSearchCriteria:::locations are ${JSON.stringify(locations)}`)
            //console.log(`ConversationsSearchCriteria:::channels are ${JSON.stringify(channels)}`)
            //console.log(`ConversationsSearchCriteria:::role are ${JSON.stringify(role)}`)
            //console.log(`ConversationsSearchCriteria:::region are ${JSON.stringify(region)}`)
            //console.log(`ConversationsSearchCriteria:::agents are ${JSON.stringify(agents)}`)
            //console.log(`ConversationsSearchCriteria:::conv_direction are ${JSON.stringify(conv_direction)}`)
            sessionStorage.setItem(constants.R2S_CONVERSATIONS,'');
            const searchCriteriaTemp = JSON.parse(sessionStorage.getItem(constants.R2S_SEARCH_CRITERIA));
            console.log(`ConversationsSearchCriteria:::: got search criteria as ${JSON.stringify(searchCriteriaTemp)}`);
            if(searchCriteriaTemp){
                try {
                    if(searchCriteriaTemp.startDateTime && searchCriteriaTemp.endDateTime){
                        let tempStartDate = new Date(searchCriteriaTemp.startDateTime);
                        console.log(`Setting Start date time as ${JSON.stringify(searchCriteriaTemp.startDateTime)}`);
                        console.log(`Setting Start date time as ${tempStartDate}`);
                        console.log(`Setting Start date time as ${typeof tempStartDate}`);
                        let tempEndDate = new Date(searchCriteriaTemp.endDateTime);
                        console.log(`Setting Start date time as ${JSON.stringify(searchCriteriaTemp.endDateTime)}`);
                        console.log(`Setting Start date time as ${tempEndDate}`);
                        console.log(`Setting Start date time as ${typeof tempEndDate}`);
                        setdateRange(tempStartDate,tempEndDate);
                    }
                    if(searchCriteriaTemp.agent){
                        console.log(`Setting Agent as ${searchCriteriaTemp.agent.split(',')}`);
                        let tempCriteria ;
                        let selectedAgentTemp ;
                        if(searchCriteriaTemp.agent == '*'){
                            selectedAgentTemp = agents.filter((x => x.value!== '*'));
                        }else{
                            tempCriteria = searchCriteriaTemp.agent.split(',');
                            selectedAgentTemp = agents.filter((x => tempCriteria.includes(x.value)));
                        }
                        console.log(`Setting Agent as ${JSON.stringify(selectedAgentTemp)}`);
                        setSelectedAgents(selectedAgentTemp);
                        //setEndDate(searchCriteriaTemp.endDateTime);
                    }

                    if(searchCriteriaTemp.conv_direction){
                        console.log(`Setting conv_direction as ${searchCriteriaTemp.conv_direction}`);
                        if(searchCriteriaTemp.conv_direction == '*'){
                            setSelectedConvDirection(conv_direction.filter((x => x.value !== '*')));
                        }else{
                            setSelectedConvDirection(conv_direction.filter((x => x.value == searchCriteriaTemp.conv_direction)));
                        }
                    }

                    if(searchCriteriaTemp.queues){
                        console.log(`Setting Queues as ${searchCriteriaTemp.queues}`);
                        let tempCriteria ;
                        let selectedQueuesTemp ;
                        if(searchCriteriaTemp.queues == '*'){
                            selectedQueuesTemp = queues.filter((x => x.value!== '*'));
                        }else{
                            tempCriteria = searchCriteriaTemp.queues.split(',');
                            selectedQueuesTemp = queues.filter((x => tempCriteria.includes(x.value)));
                        }
                        console.log(`Setting Queues as ${JSON.stringify(selectedQueuesTemp)}`);
                        setSelectedQueues(selectedQueuesTemp);
                    }

                    if(searchCriteriaTemp.division){
                        console.log(`Setting division as ${searchCriteriaTemp.division}`);
                        let tempCriteria ;
                        let selectedDivisionsTemp ;
                        if(searchCriteriaTemp.division == '*'){
                            selectedDivisionsTemp = divisions.filter((x => x.value!== '*'));
                        }else{
                            tempCriteria = searchCriteriaTemp.division.split(',');
                            selectedDivisionsTemp = divisions.filter((x => tempCriteria.includes(x.value)));
                        }
                        console.log(`Setting division as ${JSON.stringify(selectedDivisionsTemp)}`);
                        setSelectedDivisions(selectedDivisionsTemp);
                    }

                    if(searchCriteriaTemp.region){
                        console.log(`Setting Region as ${searchCriteriaTemp.region}`);
                        let tempCriteria ;
                        let selectedRegionTemp ;
                        if(searchCriteriaTemp.region == '*'){
                            selectedRegionTemp = region.filter((x => x.value!== '*'));
                        }else{
                            tempCriteria = searchCriteriaTemp.region.split(',');
                            selectedRegionTemp = region.filter((x => tempCriteria.includes(x.value)));
                        }
                        console.log(`Setting Region as ${JSON.stringify(selectedRegionTemp)}`);
                        setSelectedRegion(selectedRegionTemp);
                    }

                    if(searchCriteriaTemp.departments){
                        console.log(`Setting departments as ${searchCriteriaTemp.departments}`);
                        let tempCriteria ;
                        let selectedDepartmentTemp ;
                        if(searchCriteriaTemp.departments == '*'){
                            selectedDepartmentTemp = departments.filter((x => x.value!== '*'));
                        }else{
                            tempCriteria = searchCriteriaTemp.departments.split(',');
                            selectedDepartmentTemp = departments.filter((x => tempCriteria.includes(x.value)));
                        }
                        console.log(`Setting departments as ${JSON.stringify(selectedDepartmentTemp)}`);
                        setSelectedDepartments(selectedDepartmentTemp);
                    }

                    if(searchCriteriaTemp.titles){
                        console.log(`Setting titles as ${searchCriteriaTemp.titles}`);
                        let tempCriteria ;
                        let selectedTitlesTemp ;
                        if(searchCriteriaTemp.titles == '*'){
                            selectedTitlesTemp = titles.filter((x => x.value!== '*'));
                        }else{
                            tempCriteria = searchCriteriaTemp.titles.split(',');
                            selectedTitlesTemp = titles.filter((x => tempCriteria.includes(x.value)));
                        }
                        console.log(`Setting titles as ${JSON.stringify(selectedTitlesTemp)}`);
                        setSelectedTitles(selectedTitlesTemp);
                    }                   

                    if(searchCriteriaTemp.ani){
                        setANI(searchCriteriaTemp.ani);
                    }

                    if(searchCriteriaTemp.dnis){
                        setDNIS(searchCriteriaTemp.dnis);
                    }
                    
                    if(searchCriteriaTemp.conversationID){
                        setConversationID(searchCriteriaTemp.conversationID);
                    }
                } catch (error) {
                     console.log(error);
                }
            }
            if (!searchCriteriaTemp) return;

        } catch (error) {
            console.log('conversationsSearchCriteria.useeffect.error', error)
        }
    }, [])

    const search = async () => {
        setStartSearch(true)
        if (!dateRange[0] || !dateRange[1]) return
        console.log('Searching...')
        const searchCriteria = new Map()
        if (dateRange[0]){
            let tempStartDate = moment(dateRange[0],'YYYY-MM-DD').set({"hour": 0, "minute": 0});           
            searchCriteria.set(constants.SEARCH_PARAM_STARTDT, tempStartDate.toISOString());
        } 

        if (dateRange[1]){
            let tempEndDate = moment(dateRange[1],'YYYY-MM-DD').set({"hour": 23, "minute": 59});
            searchCriteria.set(constants.SEARCH_PARAM_ENDDT,tempEndDate.toISOString() );
        }     
        if(selectedDivisions){
            console.log(`Selected Divisions are ${JSON.stringify(selectedDivisions)}`)
            //searchCriteria.set('selectedDivisions', selectedDivisions)
            if (selectedDivisions.length === divisions.length) // all
                searchCriteria.set(constants.SEARCH_PARAM_DIVISION, '*')
            else
                searchCriteria.set(constants.SEARCH_PARAM_DIVISION, decodeURIComponent(selectedDivisions.map(x => x.value)));
        }

        if(selectedRegion){
            console.log(`Selected Regions are ${JSON.stringify(selectedRegion)}`)
            //searchCriteria.set('selectedDivisions', selectedDivisions)
            if (selectedRegion.length === region.length) // all
                searchCriteria.set(constants.SEARCH_PARAM_REGION, '*')
            else
                searchCriteria.set(constants.SEARCH_PARAM_REGION, decodeURIComponent(selectedRegion.map(x => x.value)));
        }

        if (selectedQueues) {
            //searchCriteria.set('selectedQueues', selectedQueues)
            if (selectedQueues.length === queues.length) // all
                searchCriteria.set(constants.SEARCH_PARAM_QUEUES, '*')
            else
                searchCriteria.set(constants.SEARCH_PARAM_QUEUES, decodeURIComponent(selectedQueues.map(x => x.value)));
        }
        
        if(selectedDepartments){
            //searchCriteria.set('selectedDepartments', selectedDepartments);
            if (selectedDepartments.length === departments.length) // all
                searchCriteria.set(constants.SEARCH_PARAM_DEPARTMENT, '*');
            else
                searchCriteria.set(constants.SEARCH_PARAM_DEPARTMENT, decodeURIComponent(selectedDepartments.map(x => x.value)));
        }
        if(selectedTitles){
            //searchCriteria.set('selectedTitles', selectedTitles);
            if (selectedTitles.length === titles.length) // all
                searchCriteria.set(constants.SEARCH_PARAM_TITLES, '*');
            else
                searchCriteria.set(constants.SEARCH_PARAM_TITLES, decodeURIComponent(selectedTitles.map(x => x.value)));
        }

        if(selectedAgents){
            //searchCriteria.set('selectedAgents', selectedAgents);
            if (selectedAgents.length === agents.length) // all
                searchCriteria.set(constants.SEARCH_PARAM_AGENT, '*');
            else
                searchCriteria.set(constants.SEARCH_PARAM_AGENT, decodeURIComponent(selectedAgents.map(x => x.value)));
        }

        

        if(selectedConvDirection){
            //searchCriteria.set('selectedAgents', selectedAgents);
            if (selectedConvDirection.length === conv_direction.length) // all
                searchCriteria.set(constants.SEARCH_PARAM_DIRECTION, '*');
            else
                searchCriteria.set(constants.SEARCH_PARAM_DIRECTION, decodeURIComponent(selectedConvDirection.map(x => x.value)));
        }
        if (ani) searchCriteria.set(constants.SEARCH_PARAM_ANI, decodeURIComponent(ani));
        if (dnis) searchCriteria.set(constants.SEARCH_PARAM_DNIS, decodeURIComponent(dnis));
        if (conversationID) searchCriteria.set(constants.SEARCH_PARAM_CONVERSATIONID, conversationID);

        

        props.search(utils.mapToObj(searchCriteria))
        sessionStorage.setItem(constants.R2S_SEARCH_CRITERIA, JSON.stringify(utils.mapToObj(searchCriteria)))
    }
    const cancel = async () => {
        console.log('canceling...')
        props.cancel()
    }

    const getDatePickerClassName = () => {
        return !startSearch || (startDate && endDate) ?
            'input-group d-inline-flex w-auto'
            : 'input-group d-inline-flex w-auto date-picker-error'
    }

    return (
        <div className="search-wrap pl-2 pb-2">
            <div className='row justify-content-start'>
                <div className='col col-12 col-xl-3'>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Region</span>
                        </div>
                        <MultiSelect className="multi-select region-multi-select"
                            options={region}
                            value={selectedRegion}
                            onChange={e => { setSelectedRegion(e) }}
                            labelledBy="Select"
                            required = 'true'
                        />
                    </div>
                </div>

                <div className='col col-12 col-xl-auto'>
                    <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Interval *</span>
                            </div>

                            <RangePicker size="large" aria-required placement="bottomLeft" style={{ borderRadius: "5px" }} onChange={onSelectDate} />
                    </div>                   
                </div>
            </div>

            <div className='row justify-content-start'>
                
                <div className='col col-12 col-xl-3' >
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Division</span>
                        </div>
                        <MultiSelect className="multi-select division-multi-select"
                            options={divisions}
                            value={selectedDivisions}
                            onChange={e => { setSelectedDivisions(e) }}
                            labelledBy="Select"
                        />
                    </div>
                </div>
                <div className='col col-12 col-xl-3'>
                <div className="input-group">
                    <div className="input-group-prepend">
                            <span className="input-group-text">Queues</span>
                        </div>
                        <MultiSelect className="multi-select queues-multi-select"
                            options={queues}
                            value={selectedQueues}
                            onChange={e => { setSelectedQueues(e) }}
                            labelledBy="Select"
                        />
                        
                    </div>
                </div>
                <div className='col col-12 col-xl-3'>
                <div className="input-group">
                    <div className="input-group-prepend">
                            <span className="input-group-text">Direction of the Call</span>
                        </div>
                        <MultiSelect className="multi-select direction-multi-select"
                            options={conv_direction}
                            value={selectedConvDirection}
                            onChange={e => { setSelectedConvDirection(e) }}
                            labelledBy="Select"
                        />
                        
                    </div>
                </div>
            </div>

            <div className='row justify-content-start'>
                
                
            </div>

            <div className='row justify-content-start'>
            
                <div className='col col-12 col-xl-3'>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Agent Department</span>
                        </div>
                        
                        <MultiSelect className="multi-select department-multi-select"
                            options={departments}
                            value={selectedDepartments}
                            onChange={e => { setSelectedDepartments(e) }}
                            labelledBy="Select"
                        />

                    </div>
                </div>
                <div className='col col-12 col-xl-3'>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Agent Title</span>
                        </div>
                        <MultiSelect className="multi-select titles-multi-select"
                            options={titles}
                            value={selectedTitles}
                            onChange={e => { setSelectedTitles(e) }}
                            labelledBy="Select"
                        />
                    </div>
                </div>

                <div className='col col-12 col-xl-3'>
                <div className="input-group">
                    <div className="input-group-prepend">
                            <span className="input-group-text">Agent Name</span>
                        </div>
                        <MultiSelect className="multi-select agents-multi-select"
                            options={agents}
                            value={selectedAgents}
                            onChange={e => { setSelectedAgents(e) }}
                            labelledBy="Select"
                        />
                        
                    </div>
                </div>
                
            </div>
            <div className='row justify-content-start'>
                
                <div className='col col-12 col-xl-3'>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">ANI</span>
                        </div>
                        <input className='form-control conversations-custom-control' type='text' value={ani}
                            onChange={e => setANI(e.target.value)} />
                    </div>
                </div>
                <div className='col col-12 col-xl-3'>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">DNIS</span>
                        </div>
                        <input className='form-control conversations-custom-control' type='text' value={dnis}
                            onChange={e => setDNIS(e.target.value)} />
                    </div>
                </div>
                <div className='col col-12 col-xl-3'>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Conversation ID</span>
                        </div>
                        <input className='form-control conversations-custom-control' type='text' value={conversationID}
                            onChange={e => setConversationID(e.target.value)} />
                    </div>
                </div>
            </div>
            <br />
            <div className='row justify-content-center d-flex flex-row-reverse bd-highlight'>
                <div className='col col-2 '>
                    <button type="button" className="btn btn-primary btn-space" onClick={search}>Search</button>
                    <button type="button" className="btn btn-secondary btn-space" onClick={cancel}>Cancel</button>
                </div>
            </div>
        </div>

    )


}

export default ConversationsSearchCriteria